import { CrudService } from 'ui-shared';
import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClienteAutenticacaoPortalEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class ClienteAutenticacaoPortalDataService extends CrudService<ClienteAutenticacaoPortalEntity>
{
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClientRef: HttpClient
    )
    {
        super(urlBase, httpClientRef);
        this.url = `${urlBase}/v1/ClienteAutenticacaoPortal`;
    }
}
